export default __webpack_public_path__ + "static/media/hbs-k-banner-1.2dad2c98.jpg";